import React, { useState } from 'react';
import Video from '../../videos/video.gif';
import { Button } from '../ButtonElements';
import { HeroContainer, HeroBg, VideoBg, HeroContent, HeroH1, HeroP, HeroBtnWrapper, ArrowForward, ArrowRight} from './HeroElements';


const HeroSection = () => {
  const[hover, setHover] = useState(false);

  const onHover = () => {
      setHover(!hover)
  };

 
  return (
    <HeroContainer>
        <HeroBg>
            <VideoBg autoPlay loop muted src={Video} type='gif' /> 
        </HeroBg>
        <HeroContent>
          <HeroH1> Connecting Top Talent to the Construction and Engineering Industries. </HeroH1>
          <HeroP> Let us help you find the perfect fit for your team. </HeroP>
          <HeroBtnWrapper>
            <Button to="aboutus" 
            smooth={true} 
            duration={700} 
            spy={true} 
            exact='true' 
            offset={10}
            onMouseEnter={onHover} 
            onMouseLeave={onHover}
            primary="true"
            dark="true"
            >
              Get started {hover ? <ArrowForward /> : <ArrowRight />}
            </Button>
          </HeroBtnWrapper>
        </HeroContent>
    </HeroContainer>
  );
};

export default HeroSection;
